import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface AuthContextValue {
  isAuthenticated: boolean;
  /** Courriel ou numéro utilisé pour se connecter. */
  identifier: string | null;
  login: (identifier: string) => void;
  logout: () => void;
}
const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  identifier: null,
  login: () => {},
  logout: () => {}
});

/** Code de vérification simulé pour la maquette. */
export const DEMO_CODE = '123456';

/** Temporaire : la citoyenne est connectée d'office, sans passer par le dialogue. */
const AUTO_LOGIN_IDENTIFIER = 'charlotte.bouchard@courriel.com';
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [identifier, setIdentifier] = useState<string | null>(AUTO_LOGIN_IDENTIFIER);
  const login = useCallback((value: string) => setIdentifier(value), []);
  const logout = useCallback(() => setIdentifier(null), []);
  const value = useMemo(() => ({
    isAuthenticated: identifier !== null,
    identifier,
    login,
    logout
  }), [identifier, login, logout]);
  return <AuthContext.Provider value={value} data-id="element-1947" data-mp="2v788bvug5pc6">{children}</AuthContext.Provider>;
}
export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}